var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.236C10.6152 9.27659 9.52144 10.4251 9.54848 11.8102C9.57552 13.1954 10.7132 14.3003 12.0986 14.2868C13.484 14.2733 14.6 13.1464 14.6 11.761C14.577 10.3468 13.4143 9.21763 12 9.236Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37259 5.37259 0 12 0C18.6245 0.007164 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM19.814 12.486C19.7981 13.4954 18.9674 14.301 17.958 14.286C16.949 14.3022 16.1175 13.498 16.1 12.489V11.761C16.1 9.49663 14.2644 7.661 12 7.661C9.73564 7.661 7.90001 9.49663 7.90001 11.761C7.93095 13.4759 9.02611 14.9903 10.6451 15.5569C12.264 16.1235 14.0645 15.6224 15.158 14.301C15.785 15.2327 16.835 15.7907 17.958 15.789C19.7956 15.8034 21.2975 14.3266 21.314 12.489V11.761C21.2541 6.67345 17.0877 2.59423 12 2.642C6.91232 2.59423 2.74588 6.67345 2.686 11.761C2.74588 16.8486 6.91232 20.9278 12 20.88C13.8713 20.8874 15.7023 20.3366 17.259 19.298C17.6031 19.0672 17.6949 18.6011 17.464 18.257C17.2332 17.9129 16.7671 17.8212 16.423 18.052C15.1137 18.925 13.5737 19.3874 12 19.38C7.74049 19.4284 4.24527 16.0204 4.186 11.761C4.24527 7.50162 7.74049 4.09363 12 4.142C16.2584 4.09361 19.7531 7.4998 19.814 11.758V12.486Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadEmail);
export default __webpack_public_path__ + "static/media/readEmail.f0b0d187.svg";
export { ForwardRef as ReactComponent };